import omit from 'lodash/omit';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import entity from './entity';
import {
  merge,
  mergeDeep,
} from '../../../../utils/state';
import ReduxRestEntity from '../../../../utils/reduxRestEntity';
import { TYPES } from './actions';

const coreReducer = entity.getReducer();

const INITIAL_STATE = {
  ...ReduxRestEntity.initialState,
  newEventId: null,
  isLoading: false,
  isUpdating: false,
  pagination: {
    pageSize: 15,
    pageNumber: 1,
    hasMore: false,
    totalElements: 0,
  },
};

const reducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case TYPES.UPDATE_REGISTRANT_STATE_REQUEST:
      return merge(state, {
        error: null,
        isLoading: true,
      });
    case TYPES.UPDATE_REGISTRANT_STATE_SUCCESS:
      return merge(state, {
        data: mergeDeep(state.data, action.payload),
        isLoading: false,
      });
    case TYPES.UPDATE_REGISTRANT_STATE_ERROR:
      return merge(state, {
        error: true,
        isLoading: false,
      });
    case TYPES.GET_HIRING_EVENTS_REQUEST:
      if (get(action, 'payload.page') === 1) {
        return merge(state, {
          data: {},
          error: null,
          isLoading: true,
          isUpdating: false,
          pagination: {
            pageSize: 15,
            pageNumber: 1,
            hasMore: false,
            totalElements: 0,
          },
        });
      }
      return merge(state, {
        isLoading: true,
      });
    case TYPES.GET_HIRING_EVENTS_SUCCESS:
      return merge(state, {
        isLoading: false,
        data: merge(state.data, action.payload.content),
        pagination: {
          ...state.pagination,
          pageNumber: action.payload.number + 1,
          hasMore: !action.payload.last,
          totalElements: action.payload.totalElements,
        },
      });
    case TYPES.GET_HIRING_EVENTS_FAILURE:
      return merge(state, {
        isLoading: false,
        error: isEmpty(action.payload) ? true : action.payload,
        pagination: {
          ...state.pagination,
          totalElements: 0,
        },
      });
    case TYPES.CREATE_HIRING_EVENT_REQUEST:
      return merge(state, {
        isLoading: true,
        newEventId: null,
        error: null,
      });
    case TYPES.CREATE_HIRING_EVENT_SUCCESS:
      return merge(state, {
        isLoading: false,
        newEventId: action.payload.id,
        error: null,
        data: { ...omit(action.payload, ['id']), ...state.data },
      });
    case TYPES.CREATE_HIRING_EVENT_FAILURE:
      return merge(state, {
        isLoading: false,
        newEventId: null,
        error: action.payload,
      });
    case TYPES.UPDATE_REQUEST:
      return merge(state, {
        isUpdating: true,
      });
    case TYPES.UPDATE_REQUEST_SUCCESS:
      return merge(state, {
        isUpdating: false,
        data: merge(state.data, action.payload),
      });
    case TYPES.UPDATE_REQUEST_ERROR:
      return merge(state, {
        isUpdating: false,
        error: action.payload,
      });
    case TYPES.CLEAR_NEW_HIRING_EVENT_ID:
      return merge(state, {
        newEventId: null,
      });
    case TYPES.RESET_NEW_HIRING_EVENT_ERROR:
      return merge(state, {
        error: null,
      });
    case TYPES.INCREMENT_TOTAL_EVENTS:
      return merge(state, {
        pagination: {
          ...state.pagination,
          totalElements: state.pagination.totalElements + 1,
        },
      });
    case TYPES.CLEAR_STATE:
      return INITIAL_STATE;
    default:
      return coreReducer(state, action);
  }
};

export default reducer;
